import { render } from "./NavbarAdmin.vue?vue&type=template&id=4012c4a3&ts=true"
import script from "./NavbarAdmin.vue?vue&type=script&lang=ts"
export * from "./NavbarAdmin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__